import React, { Component } from 'react';
import { Header } from './header.js';
import { Footer } from './footer.js';
import { CategorySelectorList } from './category-selector-rewrite';
import * as util from './util';
import { logBusinessActivities } from './business_activities';
import { TextInfo, TextLine, TextField, Price, Tags, CheckBox, AGBCheckBox, SubmitButton, Duallistbox, PDFUpload, MultipleFileUpload } from './common-form-components';
import { FeeBoxXU } from './feebox-xu';
import './new-services.css';

var introductoryText = "<p> <a> Der Marktplatz ermöglicht das Anbieten von Dienstleistungen oder Installationen.</a> <br/><br/> <a> Damit Ihr Angebot schneller gefunden werden kann, muss es mindestens einer Kategorie zugeordnet werden.</a> <br/><br/> <a>Dienstleistungsangebote beziehen sich immer auf Personen, nicht auf Gruppen oder Firmen.</a><br/><br/> <a>Der Gesamtpreis skaliert mit der Anzahl der ausgewählten Kategorien.</a><br/><br/> <a>Nach abgeschlossener Einstellung Ihres Angebotes bleibt dieses für ein Jahr auf der Ayacandas.com zum angegebenen Preis auffindbar.</a><br/><br/> <a>Nachträgliche Veränderungen an Ihrem Produkt, welche zu einer Preissenkung führen würden, geben kein Anrecht auf eine Rückzahlung der entstandenen Preisdifferenz.</a><br /><br /> <a>Eine kleine Anzahl der Felder sind mit einem '*' gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</a></p>"

let faqServices = [
  {
    content: "Es gibt Dienstleistungen allgemeiner Art und Dienstleistungen von Beratern. Dienstleistungsangebote von Beratern sollen sich immer auf Personen beziehen, nicht auf Gruppen oder Firmen. ",
    title: "Kann ich allgemeine Dienstleistungen anbieten?",
    key: 0
  },
  {
    content: "Alle Arten von PDF-Dokumenten können hinterlegt werden, natürlich auch ein Beraterprofil.",
    title: "Kann auch z.B. ein Beraterprofil hinterlegt werden?",
    key: 1
  },
  {
    content: "Jeder Dienstleistung muss mindestens eine Kategorie im Angebotsbaum zugeordnet werden, für die die Dienstleistung erbracht wird. Dadurch wird eine zu allgemeine Definition verhindert.",
    title: "Kann eine Dienstleistung auch allgemein definiert werden?",
    key: 2
  },
  {

    content: "Ein Platz im Marktplatz ist wie eine Anzeige und kostet Geld. Der von der Firma Ayacandas berechnete Preis ist abhängig von der Anzahl der referenzierten Kategorien. ",
    title: "Wie berechnet sich der Preis zum Einstellen der Dienstleistung? ",
    key: 3
  },
  {
    content: "Das Angebot wird im Marktplatz für den angezeigten Preis für ein Jahr lang aktiviert. (Nur nebenbei: Nachträgliche Veränderungen von Merkmalen, die zu einer Reduzierung des Preises führen, geben kein Recht auf Rückzahlung des Differenzpreises.)",
    title: "Wie lange bleibt die Anzeige einer Dienstleistung im Marktplatz erhalten?",
    key: 4
  },
];

export class CreateService extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.fetchDataAndRedirect();
  }

  fetchDataAndRedirect() {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/new-create-service`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: ''
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine neue Dienstleistung anlegen!');
        console.error(`Could not create new service!`, exception);
      });
    promise.then(function (json) {
      self.props.history.replace(`/update-service/${json.id}`);
    });
  }

  render() {
    return (
      <div className="CreateService">
      </div>
    )
  }
}

export class UpdateServiceWithFeebox extends Component {
  constructor(props) {
    super(props);
    //this.updateFeeByPrice = this.updateFeeByPrice.bind(this);
    this.updateFeeByCategories = this.updateFeeByCategories.bind(this);
    this.countCategories = this.countCategories.bind(this);
    this.state = {
      price: 0,
      categoryCount: 1
    };
  }
  /*
     updateFeeByPrice(price) {
     this.setState({price: price});
     return true;
     }
   */

  updateFeeByCategories(categories) {
    this.setState({ categoryCount: this.countCategories(categories) });
    return true;
  }


  countCategories(categories) {
    // workaround: converting String to array (FIXME)
    if ((typeof categories ) === 'string') {
      categories = categories.split(",");
    }
     console.log(categories);
     var tempCats = [];
     var count = 0;
     for (let i = 0; i < 6; i++) {
      if (categories !== undefined && categories[i] !== null && categories[i] !== "" ) {
        if (!tempCats.includes(categories[i])) {
          tempCats.push(categories[i]);
          count = count+1;
        } 
      }
    }
    return count;
  }

  render() {
    return (
      <div className="UpdateSoftwareWithFeebox" style={{ width: '100%' }} >
        <UpdateService history={this.props.history} match={this.props.match} updateFeeByCategories={this.updateFeeByCategories} />
        <FeeBoxXU type="service" categoryCount={this.state.categoryCount} feeStepConst="400"/>
      </div>
    )
  }
}


export class UpdateService extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.update = this.update.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.isValid = this.isValid.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.save = this.save.bind(this);

    this.state = {
      startID: 2,
      id: null,
      name: '',
      description: '',
      references: '',
      categories: '',
      customer_reference: '',
      warrantor: '',
      expertise: '',
      price_from: '',
      price_to: '',
      pdf_file: null,
      product_files: '',
      tags: '',
      agreement: '',
      agb_agreement: ''
    };

    this.fetchDataAndRedirect();
    this.globalFormData = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      return true;
    } else {
      return false;
    }
  }

  update(slot, value) {
    if (slot === 'categories' && this.props.updateFeeByCategories !== undefined) {
      this.props.updateFeeByCategories(value);
    }

    this.globalFormData[slot] = value;
  }

  fetchDataAndRedirect() {
    var id = this.props.match.params.id;
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/new-create-service`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: `id=${id}`
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte laden!');
        console.error(`Could not retrieve services data!`, exception);
      });
    promise.then(function (json) {
      self.setState({
        id: json.id,
        name: json.name,
        description: json.description,
        categories: json.categories,
        customer_reference: json.customer_reference,
        references: json.references,
        warrantor: json.warrantor,
        expertise: json.expertise,
        price_from: json.price_from,
        price_to: json.price_to,
        pdf_file: json.pdf_file,
        product_files: json.product_files,
        tags: json.tags,
        agreement: json.agreement,
        agb_agreement: json.agb_agreement
      });
    })
  }

  isValid(categories) {

    if (categories === undefined)
      return false;

    if (categories === null)
      return false;

    if (categories === "")
      return false;


    if (typeof categories === 'string') {
      categories = categories.split(/,/);
    }

    var catInput = categories.map(item => parseInt(item, 10));
    for (var i = 0; i < categories.length; i++) {
      if (parseInt(catInput[i], 10) === catInput[i]) {
        return true;
      }
    }
    return false;

  }

  validateInput() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
      if (this.globalFormData['name'].length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    }

    if (this.globalFormData['description'] === undefined) {
      if (this.state.description.length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.state.description.length > 2000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['description'].length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
      if (this.globalFormData['description'].length > 2000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    }

    return true;
  }

  checkRequiredFields() {

    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length < 1) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");
        return false;
      }
    }

    if ((this.globalFormData['categories'] === undefined) && (!this.isValid(this.state.categories))) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }
    if (!this.isValid(this.globalFormData['categories'])) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }

    if ((this.globalFormData['price_from'] === undefined) || (this.globalFormData['price_to'] === undefined)) {
      if ((this.state.price_from.length === 0) || (this.state.price_from.length === 0)) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    } else {
      if ((this.globalFormData['price_from'].length === 0) || (this.globalFormData['price_from'].length === 0)) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    }

    if (this.globalFormData['description'] === undefined) {
      if (this.state.description.length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    } else {
      if (this.globalFormData['description'].length < 1) {
        alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");
        return false;
      }
    }

    if (this.globalFormData['agreement'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }

    if (this.globalFormData['agreement'] === undefined) {
      if (this.state.agreement !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agb_agreement'] === false) {
      alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
      return false;
    }

    if (this.globalFormData['agb_agreement'] === undefined) {
      if (this.state.agb_agreement !== true) {
        alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
        return false;
      }
    }

    return true;
  }

  save(announce) {
    if (announce === true) {
      if (this.checkRequiredFields() === false) {
        return;
      }
    }
    if (announce === true) {
      if (this.validateInput() === false) {
        return;
      }
    }

    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var formData = new FormData();
    Object.keys(this.globalFormData).map(key => formData.append(key, self.globalFormData[key]));
    formData.append("id", this.state.id);
    if (announce === true) {
      formData.append('announce', true);
    } else {
      formData.append('announce', false);
    }
    formData.append('active', true);
    var url = `/api/new-update-service`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: formData
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte speichern!');
        console.error(`Could not save services data!`, exception);
      });
    promise.then(function (json) {
      alert('Werte wurden gespeichert.');
      if (announce === true) {
        logBusinessActivities("Dienstleistung wurde gespeichert, allem zugestimmt und veroeffentlicht.", json.id);
      }
      self.globalFormData = {};
      self.setState({
        id: json.id,
        name: json.name,
        description: json.description,
        references: json.references,
        categories: json.categories,
        customer_reference: json.customer_reference,
        warrantor: json.warrantor,
        expertise: json.expertise,
        price_from: json.price_from,
        price_to: json.price_to,
        pdf_file: json.pdf_file,
        product_files: json.product_files,
        tags: json.tags,
        agreement: json.agreement,
        agb_agreement: json.agb_agreement
      });
      self.props.history.push('/product-list');
    })
  }
    
  render() {
    return (
      <div>
        {(util.isNonCommercialUser() || util.isCommercialUser())&&
          <div className="Landing" id="contentId">
          <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
          <div className="ContentWithBackground">
          <div className="content" id="content">
          <div className="productHeader1">
                 Anbieten einer Dienstleistung
          </div>
          <div className="productHeader2">
          <TextInfo content={introductoryText} />
           {/*<TextInfo content={infotext} />*/}
           </div>
          
           <div className="productForm1  marginTop30">
           <TextLine heading=" Was bieten Sie an?" subheading="Unter diesem Titel wird ihr Produkt angezeigt." obligatory={true} maxLength='200' value={this.state.name} placeholder="was bieten Sie an" slot='name' update={this.update} />
         <CategorySelectorList value={this.state.categories} slot="categories" update={this.update} categoryLimit={6} />
           <Price heading="Listenpreis der Dienstleistung oder Installation in Euro?" subheading="Preis von:" obligatory={true}
                  maxLength='6' value={this.state.price_from} slot='price_from' update={this.update} />
           <Price subheading="Preis bis:" maxLength='6' value={this.state.price_to} slot='price_to' update={this.update} />
           <TextField heading="Beschreibung" obligatory={true} placeholder="Beschreibung" maxLength='2000' value={this.state.description} slot='description' update={this.update} />
           <TextField heading="Haben Sie Referenzen?" obligatory={false} placeholder="Referenzen" maxLength='2000' value={this.state.customer_reference} slot='customer_reference' update={this.update} />
           <PDFUpload heading="Dienstleistungs- oder Firmenprofil als PDF-Datei" subheading="Bitte wählen Sie zunächst die Dateien für den Upload von ihrem lokalen Rechner aus und drücken Sie danach Hochladen." obligatory={false} slot="pdf_file" value={this.state.pdf_file} update={this.update} />
           <TextField heading="Sind Bürgen als Referenz vorhanden?" obligatory={false} placeholder="Bürgen als Referenz" maxLength='2000' value={this.state.warrantor} slot='warrantor' update={this.update} />
           <TextField heading="Sind Sie auf bestimmte Bereiche spezialisiert?" obligatory={false} placeholder="auf bestimmte Bereiche spezialisiert" maxLength='2000' value={this.state.expertise} slot='expertise' update={this.update} />
           <Duallistbox heading="Sie können eine Dienstleistung auch spezifisch zu Produkten anbieten. Sie wird dann beim Aufruf des jeweiligen Produktes angezeigt. Bitte wählen Sie aus der Liste der verfügbaren Produkte aus." obligatory={false} value={this.state.references} slot='references' update={this.update} />
         <Tags heading="Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)" placeholder="Tags/Stichworte" value={this.state.tags} slot='tags' update={this.update} match={this.props.match} maxTags={7} maxLength={150} />
           <MultipleFileUpload heading="Hier haben Sie die Möglichkeit, Ihr Produkt als eine Datei hochzuladen." value={this.state.product_files} slot="product_files" update={this.update} />
           <CheckBox heading="* Einverständnis-Erklärung" obligatory={true} content="Ich habe die anfallenden Gebühren zum Einstellen zur Kenntnis genommen und möchte meinen Eintrag kostenpflichtig veröffentlichen." value={this.state.agreement} slot='agreement' update={this.update} />
           <AGBCheckBox obligatory={true} value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/einstellvertrag.pdf"
                        content1="Ich habe den " fileType="Einstellvertrag" content2=" gelesen und akzeptiere diesen und stehe als Ansprechpartner für das Angebot zur Verfügung." update={this.update} />

          </div>        
          <SubmitButton  history={this.props.history} onSubmit={this.save} />
          </div>
          
         </div>
         <Footer faqs={faqServices} />
         </div>
        }
         {!util.isNonCommercialUser() && !util.isCommercialUser() &&
          <div>Sie besitzen nicht genügend Rechte, um eine Dienstleistung zu erstellen.</div>
         }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/new-services.js